export default __webpack_public_path__ + "static/media/locations.e4f69c47.svg";